import React from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "@components/Breadcrumbs";
import getConfig from "next/config";

import OnlineCreditRequestForm from "@components/FinancingSolutions/OnlineCreditRequestForm";
import Heading from "@components/Heading";
import ResponsiveHeroBanner from "@components/ResponsiveHeroBanner";

const {
  publicRuntimeConfig: {
    settings: { cdn },
  },
} = getConfig();

const OnlineCredit = ({
  customer,
  onFormSubmit,
  cmsBlocks,
  credexPageConfig,
  banner,
}) => {
  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          {
            id: 1,
            level: 2,
            name: `Solutii de finantare`,
            url_key: `solutii-finantare/`,
          },
          {
            id: 1,
            level: 99,
            name: `Rate online CREDEX`,
          },
        ]}
      />

      <div className="hero-wrapper">
        {banner && <ResponsiveHeroBanner banner={banner} />}
      </div>

      {!!credexPageConfig?.creditOnline?.disclaimerBanner && (
        <small className="mt-3 text-sm leading-20 -tracking-0.29">
          {credexPageConfig.creditOnline.disclaimerBanner}
        </small>
      )}

      <Heading
        as="h1"
        display="h2"
        title="Cumpara in rate, ONLINE, in 3 pasi simpli"
        classesProp="mb-6 mt-55px hidden md:block -tracking-0.67"
      />

      <div className="flex flex-col-reverse mb-6 lg:mb-24 md:flex-row md:-mx-6 md:items-center">
        <div className="md:w-3/5 md:px-6">
          <ul className="List lg:mt-4 lg:mr-6">
            <li className="mb-6 flex items-start md:items-center">
              <div
                className={`w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo
                           text-center align-middle md:leading-loose text-2xl text-white rounded-full`}
              >
                1
              </div>
              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Alege produsele dorite, adauga-le in cosul de cumparaturi,
                selecteaza modalitatea de plata &quot;Rate online Credex&quot;
                si finalizeaza comanda
              </span>
            </li>

            <li className="mb-6 flex items-start md:items-center">
              <div
                className={`w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo
                         text-center align-middle md:leading-loose text-2xl text-white rounded-full`}
              >
                2
              </div>
              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                In noua pagina, completeaza datele solicitate, incarca actul de
                identitate si realizeaza un selfie (fotografie) conform
                recomandarilor primite
              </span>
            </li>

            <li className="mb-6 flex items-start md:items-center">
              <div
                className={`w-40px h-40px md:w-50px md:h-50px mt-1 md:mt-0 shrink-0 block mr-4 lg:mr-6 bg-indigo
                         text-center align-middle md:leading-loose text-2xl text-white rounded-full`}
              >
                3
              </div>
              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Dupa aprobare, semneaza online contractul si noi iti trimitem
                produsele prin curier direct la tine acasa
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="md:flex mb-6 lg:mb-16 md:flex-row md:-mx-6 md:items-center">
        <div className="mb-6 md:mb-0 md:w-3/5 md:px-6 text-sm">
          <div className="bg-newGray-light md:rounded-bl-2xl md:rounded-tr-2xl pt-6 pb-8 px-15px lg:px-16 lg:py-12 -mx-15px md:mx-0 lg:mr-10">
            <OnlineCreditRequestForm
              customer={customer}
              onFormSubmit={onFormSubmit}
            />
          </div>
        </div>

        <div className="md:w-2/5 md:pl-2 md:pr-6">
          <Heading
            as="h2"
            display="h2"
            title="Avantajele ratelor online de la Credex:"
            classesProp="mb-6 lg:mb-8 -tracking-0.5 lg:-tracking-0.67"
          />

          <ul className="List">
            <li className="mb-8 lg:mb-6 flex items-center">
              <img
                className="mr-4 w-50px h-50px md:w-60px md:h-60px"
                src={`${cdn}/skin/frontend/altex/altex/images/credex/icon-1.png`}
                alt=""
              />

              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Proces 100% online
              </span>
            </li>

            <li className="mb-8 lg:mb-6 flex items-center">
              <img
                className="mr-4 w-50px h-50px md:w-60px md:h-60px"
                src={`${cdn}/skin/frontend/altex/altex/images/credex/icon-3.png`}
                alt=""
              />

              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Raspuns rapid disponibil 24h / 7
              </span>
            </li>

            <li className="mb-8 lg:mb-6 flex items-center">
              <img
                className="mr-4 w-50px h-50px md:w-60px md:h-60px"
                src={`${cdn}/skin/frontend/altex/altex/images/credex/icon-2.png`}
                alt=""
              />

              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Semnarea online a contractului
              </span>
            </li>

            <li className="mb-8 lg:mb-6 flex items-center">
              <img
                className="mr-4 w-50px h-50px md:w-60px md:h-60px"
                src={`${cdn}/skin/frontend/altex/altex/images/credex/icon-4.png`}
                alt=""
              />

              <span className="text-sm leading-20 -tracking-0.29 lg:text-lg lg:leading-26 lg:-tracking-0.39">
                Fara deplasari la magazin sau banca
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="md:flex md:flex-row">
        <div className="mb-6 md:mb-0 grow md:pr-6">
          <Heading
            as="h2"
            display="h2"
            title="Conditii de eligibilitate:"
            classesProp="mt-6 mb-2 lg:my-6 -tracking-0.5 lg:-tracking-0.67"
          />

          <ul className="list-disc ml-5 text-sm md:text-base -tracking-0.29 lg:-tracking-0.33">
            <li className="u-space-mb-10">
              <span>Cetateni romani cu domiciliul in Romania</span>
            </li>

            <li className="u-space-mb-10">
              <span>Varsta cuprinsa intre 18 si 70 de ani</span>
            </li>

            <li className="u-space-mb-10">
              <span>
                Vechimea la actualul loc de munca de 3 luni neintrerupte
              </span>
            </li>

            <li className="u-space-mb-10">
              <span>Valoare credit: 300 - 30.000 lei</span>
            </li>

            <li className="u-space-mb-10">
              <span>Perioada de creditare 6-59 luni</span>
            </li>

            <li className="u-space-mb-10">
              <span>Venitul minim acceptat:</span>

              <ul className="list-inside list-none ml-4 leading-30">
                <li>- Angajati: 1.200 lei</li>
                <li>- Pensionari: 800 lei</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="md:w-380px md:pl-6">
          <Heading
            as="h2"
            display="h2"
            title="Documente necesare:"
            classesProp="my-6 -tracking-0.5 lg:-tracking-0.67"
          />

          <ul className="list-disc ml-5 text-sm md:text-base -tracking-0.29 lg:-tracking-0.33">
            <li className="u-space-mb-10">
              <span>Carte de identitate in original</span>
            </li>

            <li className="u-space-mb-10">
              <span>Talon de pensie (in cazul pensionarilor)</span>
            </li>
          </ul>
        </div>
      </div>

      {cmsBlocks["solutii-finantare_credit-online_txt"] && (
        <div
          dangerouslySetInnerHTML={{
            __html: cmsBlocks["solutii-finantare_credit-online_txt"],
          }}
        />
      )}

      {/* eslint-disable-next-line */}
      <style global jsx>{`
        .hero-wrapper img {
          width: 100%;
          border-bottom-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
      `}</style>
    </>
  );
};

OnlineCredit.propTypes = {
  customer: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
  }),
  onFormSubmit: PropTypes.func.isRequired,
};

export default OnlineCredit;
